var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHermes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.333 1333.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-787.08 500h1000V-500h-1000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-353.557 487.633H646.444v-1000h-1000z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-523.354 537.512h1000v-1000h-1000z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-778.81 604.513h1000v-1000h-1000z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-763.011 649.178h1000v-1000h-1000z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-598.21 146.682h1000v-1000h-1000z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-158.55-128.53-287.079-287.079-287.079-158.55 0-287.08 128.529-287.08 287.079s128.53 287.079 287.08 287.079S0 158.55 0 0",
    clipPath: "url(#a)",
    style: {
      fill: "#e0a800",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#002566",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 1049.44 666.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-43.616 30.267c-.089 3.753 20.698 4.606 23.903 2.81zm66.202 145.027c5.965-4.846 16.391-14.489 17.972-22.146 4.124-19.973-12.69-33.279 6.693-49.629 19.907-16.792 37.217-19.579 41.146-51.801 1.611-13.209-6.436-13.513-10.927-24.263l-8.74 29.954C103.361 52.53 71.844 61.11 64.707 86.519c-5.388 19.181 7.673 38.708 1.495 58.508M53.508-38.018 24.375-20.704C11.202 17.28-32.781 51.657-14.325 95.291c6.735 15.924 27.529 31.555-5.388 37.072l1.631 6.825C32.48 143.309 2.37 104.628.02 80.944-4.036 40.06 21.875 33.003 38.259 3.747c6.972-12.449 11.102-28.172 15.249-41.765M37.433 40.234C51.822 22.101 74.523 6.565 78.25-16.932c2.009-12.668-2.594-25.308-.812-37.991l-9.518 5.951c-4.198 20.891-10.397 44.08-21.208 62.58-8.149 13.944-31.2 32.963-34.779 46.891-2.219 8.637-1.835 27.131 4.957 33.836-1.524-22.561 7.352-37.477 20.543-54.101m72.405-113.449c-31.53 8.64-17.109 37.13-19.869 59.674-5.391 44.034-67.997 56.978-60.272 115.502 2.129 16.137 18.784 26.882 13.335 44.551-3.002 9.732-33.652 26.021-35.341 11.904-1.057-8.836 8.622-4.69 12.996-5.956 5.093-1.473 17.136-11.812 11.56-17.857l-9.696-14.915c.142 7.908-1.91 18.214-7.772 23.918-6.359 6.187-16.373 4.467-10.884 17.958 6.299 15.483 34.959 4.861 43.314-5.241 17.483-21.137 3.668-37.986 3.646-58.316-.043-42.274 37.096-44.323 51.08-75.644 3.257-7.293 7.311-24.787 7.897-32.95 1.513-21.071-7.213-41.617.006-62.628m129.547-2.83h-23.234c-1.759 0-4.761 6.689-4.551 8.947.807 8.658 21.208 28.594 30.596 19.876-4.762-9.182-5.664-18.862-2.811-28.823m33.793-81.656-98.559 46.439c28.506 2.518 60.483 3.223 80.976-19.682 2.034-2.273 18.781-25.695 17.583-26.757m47.876-19.713-29.248 10.157c-12.452 27.469-28.588 54.465-59.158 64.058-11.416 3.583-23.753 3.633-35.5 5.322 14.449 11.988 37.829 9.649 55.225 5.954 20.457-4.345 31.977-19.146 43.068-35.785 10.396-15.596 17.397-32.946 25.613-49.706M49.297-209.821c-60.675 6.964-122.171 8.984-182.328 19.77-1.975.354-4.151-1.347-3.535 2.042 19.221 19.336 49.947 26.332 76.662 27.545 43.997 1.998 86.916-8.825 128.908-19.794-10.93-8.117-22.464-13.273-19.707-29.563M478.332-14.494c-3.012 3.605-8.479 4.033-7.964 12.286.928 14.869 19.19 3.526 24.921 2.538 14.903-2.567 26.816 7.94 34.533 6.484 10.903-2.057 8.545-18.961 5.941-26.508-7.674-22.238-44.968-77.291-42.97-96.416.662-6.348 4.771-12.482 5.563-18.491 2.12-16.099-2.808-40.714-6.169-56.956-1.066-5.147-6.595-32.621-10.12-33.587-49.099 8.93-97.602 22.295-143.772 41.026-19.245 39.6-32.811 82.624-75.419 102.691-2.513 1.184-8.523 2.146-9.533 3.479-.875 1.155-4.13 12.047-4.134 13.868-.021 10.235 10.867 13.237 2.167 24.668-16.175 21.251-54.111-8.423-51.345-33.045.308-2.742 3.561-5.646 2.152-7.84-29.825-21.243-78.752-27.809-82.538 20.395-2.149 27.361 8.916 54.18 28.88 72.604 10.051 9.276 32.361 27.158 44.467 13.416 3.441-3.905 8.52-27.024 16.717-15.457 5.077 7.165-5.217 23.518-11.084 28.13-9.299 7.311-20.746 5.289-31.034 1.313-9.548-3.689-16.209-11.449-25.358-14.759.301 16.508-13.155 36.925-26.056 46.468-5.492 4.062-18.38 8.629-20.753 14.433-2.938 7.189 1.26 15.161 1.673 22.81 1.768 32.731-16.166 40.831-39.815 55.932-5.278 3.37-9.822 8.128-15.482 11.272-3.288 1.826-10.816 3.45-12.232 4.664-1.323 1.135-3.768 11.22-5.379 14.335-16.359 31.635-44.935 48.823-74.843 65.967l-46.487 21.778c72.255 18.965 142.235 47.302 206.005 86.182 80.84 49.288 142.619 124.63 247.372 80.674 27.156-11.394 57.007-33.856 76.028-56.333 1.715-2.027 12.959-16.527 13.453-17.599.555-1.204.883-1.785.509-3.211-1.233-4.702-33.846-30.656-39.946-34.815-29.809-20.324-66.186-29.216-94.397-52.053-2.949-.465-1.673.42-2.238 1.926-2.585 6.889-9.301 31.738-9.641 38.387-.569 11.139 12.766 31.878-2.176 32.957-3.254-.446-5.178-5.004-6.268-7.881-13.994-36.949 11.711-73.297 22.825-106.568 7.169-21.459 5.011-44.15 19.377-62.294 4.56-5.76 11.321-10.02 15.454-16.213-49.808-5.823-137.481-43.968-146.099-99.617-1.378-8.903-.285-15.583 9.645-9.653 15.407 66.998 97.888 90.815 157.285 101.802 36.954 6.835 118.63 25.671 103.836-39.062-1.758-7.69-9.083-19.05-7.787-25.951 1.61-8.566 18.607-5.637 20.835-12.993 2.212-7.305-2.031-12.313-3.964-18.74-13.934 5.923-30.848 10.909-45.842 7.138-2.722-18.796 13.054-10.551 22.454-11.416 7.723-.71 23.387-11.511 29.155-6.42 2.481 2.189 2.12 7.459 4.793 6.461 9.775-6.111 1.088-15.928.679-24.693-.473-10.114 5.007-18.293 15.526-18.961-.581-2.981-6.615-2.958-8.971-2.738-8.898.832-11.18 8.257-22.73 7.02-21.629-2.317-26.453-27.737-9.19-40.225 9.412-6.808 14.353 1.572 9.491 7.391m87.725-224.883-69.029 10.515 4.928 24.721 13.785-3.193c10.313-4.604 21.886-9.154 31.555-14.912 1.778-1.058 22.031-14.368 18.761-17.131m-1.401-12.695c-5.682-8.592-19.581-11.863-29.23-13.703-95.53-18.214-201.357 21.491-284.315 66.983-78.835 43.23-162.489 96.599-236.06 148.352-25.11 17.664-58.011 36.489-64.313 68.738 26.068-13.88 46.993-35.417 70.783-52.411 73.52-52.52 170.762-102.543 253.522-139.339 91.84-40.835 189.565-67.421 289.613-78.62M35.199-222.469c-8.645-3.657-20.293-12.587-22.201-22.162-.726-3.645 1.029-14.922-2.369-15.517-2.748.959-5.612 1.335-8.537 1.166-64.923-3.761-129.637-10.625-194.127-19.993-9.681-1.407-19.307-4.213-29.023-5.462-1.78 1.661 12.816 17.814 14.757 19.764 58.021 58.31 154.224 48.926 229.533 44.993zm-53.497-98.568c-89.582-13.406-177.653-39.346-254.852-87.32-2.421 3.334 12.023 29.099 14.889 33.676 37.92 60.552 115.789 85.28 183.169 95.635 25.302 3.888 50.866 6.618 76.5 5.853-.587-2.304-4.11-2.382-6.343-4.198-13.821-11.241-21.242-26.152-13.363-43.646m-192.093-144.461c-6.843-5.325-13.498-10.979-20.517-16.08-.822 19.179 6.195 37.177 17.144 52.544 54.887 77.038 206.601 99.916 294.745 109.38 39.399 4.23 87.26-1.631 114.722 33.128 22.306 28.233 8.978 63.503-25.713 69.467-11.901-11.354 3.17-13.757 10.157-18.902 22.523-16.586 11.166-41.908-8.775-54.396-25.45-15.937-72.901-13.403-103.064-16.624-25.127-2.683-50.112-7.781-75.191-9.686-7.472 32.176 33.993 42.442 58.301 44.881 21.657 2.174 40.696-.616 61.877-1.445 9.588-.375 15.784-.221 12.814 11.403-11.472 5.107-24.593 1.18-36.62 4.205-8.003-.403-16.071.302-24.063-.009-8.709-.338-24.442-3.975-32.228-2.798-11.956 1.807-8.387 13.244-1.543 19.671 18.085 16.983 50.404 13.022 72.815 9.389 6.387-1.035 20.122-6.348 24.732-4.174 6.234 2.94 5.69 9.664-.673 12.737-7.883 3.808-33.553 6.75-43.72 8.38-6.754 1.083-27.519-.332-22.19 11.596 6.741 15.091 45.362 13.401 58.808 10.941 6.811-1.246 21.447-8.601 26.008-4.816 14.098 11.698-23.339 18.231-30.023 19.106-43.389 5.682-80.588 22.256-123.943 28.133-11.317 1.534-22.794 1.007-33.987 3.311-8.12 37.531-.195 76 9.561 112.348L1.539-56.911c85.432-57.441 171.034-115.222 262.692-162.555 62.544-32.299 130.26-55.82 200.447-64.995-34.054-48.205-83.676-86.598-140.81-103.476-65.918-19.472-156.762-18.519-219.355 11.568-1.673.804-4.164.757-4.53 3.201 26.78 2.756 54.245 2.339 80.944 5.668 85.15 10.617 132.189 104.056 54.677 158.833-6.856 4.844-25.857 16.428-33.228 18.887-8.835 2.948-12.552-4.806-8.139-10.98 2.572-3.597 29.94-16.265 37.162-21.969 34.021-26.869 38.726-67.978 10.115-101.159-31.007-35.962-83.897-29.671-126.735-33.788-123.068-11.829-225.483-30.254-325.17-107.822m2.816-15.489c81.04 64.773 175.396 95.705 278.609 104.958 71.839-38.535 150.711-47.724 230.572-31.889 77.105 15.289 135.187 59.647 179.959 122.783 28.019 3.657 80.801.297 96.376 28.946 11.991 22.057-7.705 35.491-24.663 45.557-14.882 8.834-31.301 15.004-47.864 19.959 2.611 19.543 8.891 42.188 5.005 61.912-1.081 5.49-5.521 11.187-4.653 16.444 10.831 29.423 32.482 59.518 42.261 88.808 6.528 19.553 2.25 38.423-18.857 45.044-4.867 1.526-20.334 2.499-22.042 7.56-3.487 10.335 11.77 18.424-2.111 35.168-1.253 1.512-4.996 2.573-5.785 4.652-.506 1.333.955 7.167.547 10.504-1.253 10.241-10.734 18.728-21.016 19.156 9.487 17.79 12.72 38.106 4.019 56.809-18.037 38.773-85.445 19.853-118.14 14.334-4.775 6.514-13.167 11.291-18.303 16.787-13.814 14.78-11.364 31.861-16.12 50.061-3.386 12.961-10.036 25.108-13.185 37.783 33.646 23.783 72.458 34.838 105.87 59.602 5.949 4.409 37.351 31.302 38.724 35.98 1.517 5.163-2.537 9.99-5.077 14.088-18.563 29.94-61.107 63.128-93.3 77.081-113.319 49.116-177.454-30.014-264.787-82.922-57.448-34.803-125.277-62.252-189.985-80.37-6.267-1.755-35.596-7.16-37.363-10.541-1.568-3.001-.671-6.084 2.236-7.697 51.443-22.408 119.196-41.17 142.144-97.918-16.802-.246-27.242-14.931-25.339-30.999-24.769 6.373-33.869-33.575-5.641-30.978 1.444-1.345-10.521-20.15-11.951-23.947-6.571-17.46-2.568-31.741.69-49.261-30.6.552-42.564-19.771-29.831-47.438 4.168-9.057 12.025-15.71 15.617-25.05-13.765-38.692-19.728-81.11-12.547-121.827-30.914.187-63.104-6.13-87.76-25.597-33.558-26.496-3.549-28.353 21.061-31.963 1.276-.187 14.95.494 10.373-2.991-43.258-1.72-93.83-26.441-118.849-62.092-29.594-42.171 24.761-23.585 46.759-21.402 1.549.154 4.787 1.667 4.498-.982-38.823-14.562-75.451-44.595-95.982-80.742-4.738-8.341-12.374-23.114-14.26-32.206-8.029-38.72 31.205-7.757 45.449-.392 20.57 10.636 41.425 21.33 63.395 28.823-38.051-27.261-70.828-62.584-64.804-113.371.545-4.596 3.676-10.702 9.012-10.508 5.678.206 21.194 15.612 27.039 20.284",
    clipPath: "url(#b)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.54881 0 0 .52363 550.166 673.143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.889 4.167-9.994 10.808-5.173 16.917.681.862 18.304 10.01 19.475 10.188 4.358.662 5.775-3.133 8.324-3.594 7.405-1.342 9.354 7.377 4.033 12.31-12.716 11.789-31.277-5.432-42.994-11.97-3.812-5.287-2.874-14.574-.671-20.406C-14.627-2.855.641-20.491.67-22.657c.072-5.426-11.359-5.115-15.328-3.964-25.369 7.352-20.821 49.723-3.148 61.798 2.794 1.909 5.287 1.66 7.062 2.786 5.403 3.428 2.085 15.525-9.083 7.681-20.261-14.231-29.456-52.242-13.377-72.513 8.287-10.448 24.458-13.582 36.61-8.449C21.983-27.472 6.873-9.914 0 0",
    clipPath: "url(#c)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.54881 0 0 .52363 643.353 647.025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-9.234-.391-17.357 4.064-25.36 7.759.113 5.846 20.069 14.262 25.36 16.179Zm11.258-2.823c.974 7.443-1.766 14.489-1.467 21.865.225 5.568 6.22 18.218-.951 20.187-3.566.98-24.068-7.862-28.577-10.34-3.966-2.179-16.693-12.985-17.779-13.2-1.11-.22-20.768 11.224-15.786-3.489 1.863-5.502 38.053-20.4 45.161-22.453 7.766-2.243 29.761-7.016 36.726-4.947 4.48 1.331 5.31 8.349 1.819 11.112-3.696 2.925-14.205.505-19.146 1.265",
    clipPath: "url(#d)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.54881 0 0 .52363 783.55 611.941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c13.987-1.672 29.854-.22 43.322 3.766 6.134 1.815 27.742 10.188 28.809 16.312 3.142 18.029-22.501.571-29.19-1.85C7.652 5.455-16.07 15.197-45.214 35.048c-5.46 3.72-9.213 12.192-16.284 4.497-2.011-5.703 5.712-11.805 9.827-15.178C-40.008 14.806-14.896 1.781 0 0",
    clipPath: "url(#e)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.54881 0 0 .52363 774.88 588.553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.681 1.815 23.148 28.994c2.587 4.971-2.025 8.978-6.792 9.53-4.304-.623-24.288-25.57-25.657-30.634C-6.068 4.346-5.672 1.67 0 0",
    clipPath: "url(#f)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.54881 0 0 .52363 684.435 851.675)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-29.705 1038.201 -721.204)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2365px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "H")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-19.801 1396.042 -1352.203)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2364px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-9.874 2468.784 -3210.94)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "R")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(1.066 -19355.078 34590.023)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "M")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(11.683 -1444.97 3616.612)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2363px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(21.212 -632.162 2194.181)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2368px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "S")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(27.953 -397.353 1800.494)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2365px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(31.899 -302.328 1630.408)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2364px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(70.69 -375.986 606.563)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "C")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(64.447 -474.1 675.412)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(58.916 -562.374 725.337)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9998px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(51.014 -728.02 828.3)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(45.406 -885.706 939.594)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(39.693 -1072.735 1043.044)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(31.1 -1495.333 1310.725)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "P")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(22.795 -2195.31 1749.993)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(14.45 -3694.107 2689.843)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "X")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(8.552 -6510.364 4544.028)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(3.066 -18788.246 12199.97)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "F")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-4.397 13683.902 -8252.864)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "L")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-9.903 6248.975 -3638.756)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-16.494 3880.214 -2050.918)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "G")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-25.869 2576.046 -1240.73)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9997px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "H")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-34.15 2011.43 -894.959)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-39.64 1759.152 -756.39)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-45.117 1576.795 -621.847)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-53 1372.039 -490.602)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-61.607 1204.872 -383.396)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-71.315 1061.864 -289.518)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9997px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "M")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHermes);
export default __webpack_public_path__ + "static/media/HERMES.15ccc1fffaeb9d4a51ae78ca52ee4d59.svg";
export { ForwardRef as ReactComponent };